export default "__VITE_ASSET__d7610cc7__"